/* Tidal Dream - Theme JavaScript */

/* Age Gate */
function enterSite() {
  var g = document.getElementById('ageGate');
  if (!g) return;
  g.style.transition = 'opacity .5s';
  g.style.opacity = '0';
  setTimeout(function() { g.style.display = 'none'; }, 500);
  // Store in localStorage so it persists across pages and sessions
  try { localStorage.setItem('td_age_verified', '1'); } catch(e) {}
}

// On page load, check if already verified
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (localStorage.getItem('td_age_verified') === '1') {
      var g = document.getElementById('ageGate');
      if (g) g.style.display = 'none';
    }
  } catch(e) {}
});

/* Cart count (basic client-side counter for demo; integrate with Shopify cart API in production) */
var cc = 0;
function addCart() {
  cc++;
  var el = document.getElementById('cartCount');
  if (el) el.textContent = cc;
  toast('Added to cart ✓');
}

/* Toast notifications */
function toast(m) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = m;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2500);
}

/* Quantity controls */
function chgQty(d) {
  var i = document.getElementById('qtyI');
  if (!i) return;
  var v = parseInt(i.value) + d;
  if (v < 1) v = 1;
  if (v > 10) v = 10;
  i.value = v;
}

/* FAQ accordion */
function toggleFaq(el) {
  el.classList.toggle('open');
  el.nextElementSibling.classList.toggle('open');
}

/* Product accordion */
function toggleAcc(el) {
  el.classList.toggle('open');
  el.nextElementSibling.classList.toggle('open');
}

/* Newsletter form handler */
function handleNL(e) {
  e.preventDefault();
  toast('Welcome to the community');
  e.target.reset();
}

/* Filter tabs (Characters page) */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.filter-tab').forEach(function(t) {
    t.addEventListener('click', function() {
      document.querySelectorAll('.filter-tab').forEach(function(x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* Product detail thumbnail selector */
  document.querySelectorAll('.pd-thumb').forEach(function(t) {
    t.addEventListener('click', function() {
      document.querySelectorAll('.pd-thumb').forEach(function(x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* Option button selector */
  document.querySelectorAll('.opt-btn:not(.unavailable)').forEach(function(b) {
    b.addEventListener('click', function() {
      this.closest('.opt-btns').querySelectorAll('.opt-btn').forEach(function(x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* Color dot selector */
  document.querySelectorAll('.c-dot').forEach(function(d) {
    d.addEventListener('click', function() {
      document.querySelectorAll('.c-dot').forEach(function(x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* Highlight active nav link based on current URL */
  var path = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(function(a) {
    a.classList.remove('active');
    var href = a.getAttribute('href');
    if (href === '/' && path === '/') {
      a.classList.add('active');
    } else if (href && href !== '/' && path.indexOf(href) === 0) {
      a.classList.add('active');
    }
  });
});
